import { CycleUtils } from '@wix/package-picker-shared';
import { useSwitchFlows } from '@wix/package-picker-shared-eclipse';
import { CycleSelector as PlatformCycleSelector } from '@wix/premium-purchase-platform/@components';
import React from 'react';

import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import { CycleSelectorItem } from './CycleSelectorItem';

export const CycleSelector = () => {
  const selectedProductId =
    EclipsePackagePickerModule.SDK.PackagePickerStore.useSelectedProductId();

  const { isUpgradeFlow } = useSwitchFlows();

  if (!selectedProductId) {
    // Should not get to here because of RouteGuard
    return null;
  }

  return (
    <PlatformCycleSelector.Root
      productId={selectedProductId}
      gap="SP2"
      width="100%"
      maxWidth="720px"
    >
      {(pricingDetails) => {
        return pricingDetails.map((pricingDetail) => {
          const { cycle } = pricingDetail;

          if (!cycle) {
            return null;
          }

          return (
            <CycleSelectorItem
              key={CycleUtils.convertCycleToCycleId(cycle)}
              cycleId={CycleUtils.convertCycleToCycleId(cycle)}
              productId={selectedProductId}
              isUpgradeFlow={isUpgradeFlow}
            />
          );
        });
      }}
    </PlatformCycleSelector.Root>
  );
};
